export const carousel = {
  type: "carousel",
  id: "90176625-39f3-4fd2-8219-b2a4cc6ee04e",
  analyticTitle: "Home Page Carousel",
  buttonStyle: "Primary",
  items: [
    {
      id: "61bed040-496f-4651-90be-9569d5b4ee45",
      title: "Apple iPhone x",
      heading: "Just the right amount of everything",
      description: "",
      image: "http://3.250.153.131/sites/default/files/2020-06/carousel2.png",
      callToActionUri: "http://example.com",
      callToActionLabel: "Shop now",
    },
    {
      id: "a46b7546-97c3-4801-8cd5-bb49ea7b1270",
      title: "Samsung",
      heading: "Built for sound inside  and out",
      description: "",
      image: "http://3.250.153.131/sites/default/files/2020-08/background.png",
      callToActionUri: "http://example.com",
      callToActionLabel: "Shop now",
    },
  ],
};

export const image_card = {
  type: "image_card",
  id: "a4b5eeb3-87d9-41b8-97fa-5b3872d8eba8",
  analyticTitle: "Get covered",
  title: "Get covered",
  description: "",
  buttonStyle: "Outline White",
  imageCardType: "3*3",
  tabStyle: "large-black",
  tabType: "tab",
  items: {
    Insurance: [
      {
        id: "ea8cb45f-d771-4471-982a-8eeb78534948",
        title: "DEVICE COVER",
        description: "<p>Protect your gadgets from damage, loss and theft</p>",
        category: "Insurance",
        image: "http://3.250.153.131/sites/default/files/2020-07/image_13.png",
        icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
        callToActionUri: "http://google.com",
        callToActionLabel: "Learn more",
      },
      {
        id: "0c55dfda-dc99-474e-92e6-169613e7dc8e",
        title: "DEVICE COVER",
        description: "<p>Protect your gadgets from damage, loss and theft</p>",
        category: "Insurance",
        image:
          "http://3.250.153.131/sites/default/files/2020-06/insurance3.png",
        icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
        callToActionUri: "http://google.com",
        callToActionLabel: "Learn more",
      },
      {
        id: "4cec40af-c7c9-41f9-b817-19fb9126af94",
        title: "DEVICE COVER",
        description: "<p>Protect your gadgets from damage, loss and theft</p>",
        category: "Insurance",
        image:
          "http://3.250.153.131/sites/default/files/2020-06/insurance3.png",
        icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
        callToActionUri: "http://google.com",
        callToActionLabel: "Learn more",
      },
      {
        id: "a9d383f1-b6f9-4766-800f-02b3eeb2621a",
        title: "DEVICE COVER First element",
        description: "<p>Protect your gadgets from damage, loss and theft</p>",
        category: "Insurance",
        image:
          "http://3.250.153.131/sites/default/files/2020-06/insurance3.png",
        icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
        callToActionUri: "http://test.com",
        callToActionLabel: "Learn more",
      },
      {
        id: "20d229aa-4f02-4d4f-b9b3-2b636672a882",
        title: "DEVICE COVER",
        description: "<p>Protect your gadgets from damage, loss and theft</p>",
        category: "Insurance",
        image:
          "http://3.250.153.131/sites/default/files/2020-06/insurance2.png",
        icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
        callToActionUri: "http://example.com",
        callToActionLabel: "Learn more",
      },
      {
        id: "6b15fdd7-8877-4988-80a0-c76fe21b9108",
        title: "DEVICE COVER",
        description: "<p>Protect your gadgets from damage, loss and theft</p>",
        category: "Insurance",
        image:
          "http://3.250.153.131/sites/default/files/2020-06/insurance2.png",
        icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
        callToActionUri: "http://example.com",
        callToActionLabel: "Learn more",
      },
    ],
  },
};
export const product_card = {
  type: "product_card",
  id: "a4b5eeb3-87d9-41b8-97fa-5b3872d8eba8",
  analyticTitle: "Get covered",
  title: "Get covered",
  description: "",
  buttonStyle: "Outline White",
  imageCardType: "3*3",
  tabStyle: "large-black",
  tabType: "tab",
  items: {
    Insurance: [
      {
        id: "ea8cb45f-d771-4471-982a-8eeb78534948",
        title: "DEVICE COVER",
        description: "<p>Protect your gadgets from damage, loss and theft</p>",
        category: "Insurance",
        image: "http://3.250.153.131/sites/default/files/2020-07/image_13.png",
        icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
        callToActionUri: "http://google.com",
        callToActionLabel: "Learn more",
      },
      {
        id: "0c55dfda-dc99-474e-92e6-169613e7dc8e",
        title: "DEVICE COVER",
        description: "<p>Protect your gadgets from damage, loss and theft</p>",
        category: "Insurance",
        image:
          "http://3.250.153.131/sites/default/files/2020-06/insurance3.png",
        icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
        callToActionUri: "http://google.com",
        callToActionLabel: "Learn more",
      },
      {
        id: "4cec40af-c7c9-41f9-b817-19fb9126af94",
        title: "DEVICE COVER",
        description: "<p>Protect your gadgets from damage, loss and theft</p>",
        category: "Insurance",
        image:
          "http://3.250.153.131/sites/default/files/2020-06/insurance3.png",
        icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
        callToActionUri: "http://google.com",
        callToActionLabel: "Learn more",
      },
      {
        id: "a9d383f1-b6f9-4766-800f-02b3eeb2621a",
        title: "DEVICE COVER First element",
        description: "<p>Protect your gadgets from damage, loss and theft</p>",
        category: "Insurance",
        image:
          "http://3.250.153.131/sites/default/files/2020-06/insurance3.png",
        icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
        callToActionUri: "http://test.com",
        callToActionLabel: "Learn more",
      },
      {
        id: "20d229aa-4f02-4d4f-b9b3-2b636672a882",
        title: "DEVICE COVER",
        description: "<p>Protect your gadgets from damage, loss and theft</p>",
        category: "Insurance",
        image:
          "http://3.250.153.131/sites/default/files/2020-06/insurance2.png",
        icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
        callToActionUri: "http://example.com",
        callToActionLabel: "Learn more",
      },
      {
        id: "6b15fdd7-8877-4988-80a0-c76fe21b9108",
        title: "DEVICE COVER",
        description: "<p>Protect your gadgets from damage, loss and theft</p>",
        category: "Insurance",
        image:
          "http://3.250.153.131/sites/default/files/2020-06/insurance2.png",
        icon: "http://3.250.153.131/sites/default/files/2020-07/cellphone-o-copy_0.png",
        callToActionUri: "http://example.com",
        callToActionLabel: "Learn more",
      },
    ],
  },
};
export const portlet = {
  type: "portlet",
  id: "ba640131-8199-4576-beb4-d7f8f147ae01",
  analyticTitle: "Explore Our Portlet",
  title: "Explore our range",
  description: "",
  buttonStyle: "Primary",
  tabStyle: "red-without-line",
  tabType: "pill",
  items: {
    Bestseller: [
      {
        id: "01f7a87d-b06b-4a2c-b1da-49c9b0750633",
        title: "Apple Airpods with case",
        description:
          "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
        category: "Bestseller",
        badgeStyle: "Badge Style 1",
        fromLabel: null,
        badgeLabel: "Brand New",
        left: "30",
        top: "50",
        image: "http://3.250.153.131/sites/default/files/2020-06/image.png",
        imageHeading: "Airpods",
        placement: "bottom",
        addOn: "+ Free charger",
        imageDescription: "Amazing Sound",
        callToActionUri: "http://example.com",
        callToActionLabel: "Shop now",
      },
      {
        id: "c8ac7c0f-7494-4a81-8617-ceea9fb77fcf",
        title: "Apple Airpods with case",
        description:
          "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
        category: "Bestseller",
        badgeStyle: "Badge Style 1",
        fromLabel: null,
        badgeLabel: "Brand New",
        left: null,
        top: null,
        image: "http://3.250.153.131/sites/default/files/2020-06/image.png",
        imageHeading: null,
        placement: null,
        addOn: "+ Free charger",
        imageDescription: null,
        callToActionUri: "http://example.com",
        callToActionLabel: "Shop now",
      },
      {
        id: "43493998-ea9e-4957-9665-a6b33b753b41",
        title: "Apple Airpods with case",
        description:
          "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
        category: "Bestseller",
        fromLabel: null,
        badgeLabel: null,
        left: null,
        top: null,
        image: "http://3.250.153.131/sites/default/files/2020-06/image_1.png",
        imageHeading: null,
        placement: null,
        addOn: "+ Free charger",
        imageDescription: null,
        callToActionUri: "http://example.com",
        callToActionLabel: "Shop now",
      },
      {
        id: "78595c66-3469-4b8a-aa86-b3cbf91d7fea",
        title: "Apple Airpods with case",
        description:
          "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
        category: "Bestseller",
        badgeStyle: "Badge Style 1",
        fromLabel: null,
        badgeLabel: "Double Deals",
        left: null,
        top: null,
        image: "http://3.250.153.131/sites/default/files/2020-06/image_0.png",
        imageHeading: null,
        placement: null,
        addOn: "+ Free charger",
        imageDescription: null,
        callToActionUri: "http://example.com",
        callToActionLabel: "Shop now",
      },
      {
        id: "e38746be-a56b-4d6a-be73-26777cfdf832",
        title: "Apple Airpods with case",
        description:
          "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
        category: "Bestseller",
        badgeStyle: "Badge Style 1",
        fromLabel: null,
        badgeLabel: "Double Deals",
        left: null,
        top: null,
        image: "http://3.250.153.131/sites/default/files/2020-06/image_0.png",
        imageHeading: null,
        placement: null,
        addOn: "+ Free charger",
        imageDescription: null,
        callToActionUri: "http://example.com",
        callToActionLabel: "Shop now",
      },
      {
        id: "760b1947-fcf0-4edd-86e8-e4ba19375b0b",
        title: "Apple Airpods with case",
        description:
          "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
        category: "Bestseller",
        badgeStyle: "Badge Style 1",
        fromLabel: null,
        badgeLabel: "Double Deals",
        left: null,
        top: null,
        image: "http://3.250.153.131/sites/default/files/2020-06/image_0.png",
        imageHeading: null,
        placement: null,
        addOn: "+ Free charger",
        imageDescription: null,
        callToActionUri: "http://example.com",
        callToActionLabel: "Shop now",
      },
    ],
    "Latest Special": [
      {
        id: "e7632532-6770-4b61-9599-7965769da27f",
        title: "Apple Airpods with case",
        description:
          "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
        category: "Latest Special",
        fromLabel: null,
        badgeLabel: null,
        left: null,
        top: null,
        image: "http://3.250.153.131/sites/default/files/2020-06/image_1.png",
        imageHeading: null,
        placement: null,
        addOn: "+ Free charger",
        imageDescription: null,
        callToActionUri: "http://example.com",
        callToActionLabel: "Shop now",
      },
      {
        id: "73a4af96-96c4-4ea1-af30-ebd1d1149f8e",
        title: "Apple Airpods with case",
        description:
          "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
        category: "Latest Special",
        fromLabel: null,
        badgeLabel: null,
        left: null,
        top: null,
        image: "http://3.250.153.131/sites/default/files/2020-06/image_1.png",
        imageHeading: null,
        placement: null,
        addOn: "+ Free charger",
        imageDescription: null,
        callToActionUri: "http://example.com",
        callToActionLabel: "Shop now",
      },
      {
        id: "1182a84f-b131-43e0-a04e-cbb2106873e5",
        title: "Apple Airpods with case",
        description:
          "<p>A massive leap forward in resolution and zoom for mobile photography</p>",
        category: "Latest Special",
        fromLabel: null,
        badgeLabel: null,
        left: null,
        top: null,
        image: "http://3.250.153.131/sites/default/files/2020-06/image_1.png",
        imageHeading: null,
        placement: null,
        addOn: "+ Free charger",
        imageDescription: null,
        callToActionUri: "http://example.com",
        callToActionLabel: "Shop now",
      },
    ],
  },
};

export const product_catalog = {
  type: "product_catalog",
  id: "5af3586b-1926-4e5c-bec3-03597432328c",
  analyticTitle: "CBU: Product Catalog",
  title: "Shop By",
  description: "<p>Category</p>",
  buttonLabel: "Shop all",
  buttonStyle: "Outline White",
  tabStyle: "black-with-line",
  tabType: "tab",
  displayStyle: "Grid",
  productCategory: {
    1035: {
      id: "66",
      name: "Routers",
    },
    1040: {
      id: "55",
      name: "Smart watches",
    },
    1041: {
      id: "56",
      name: "Portable Audio",
    },
    1050: {
      id: "49",
      name: "Phones",
    },
    1067: {
      id: "82",
      name: "Printers & Scanners",
    },
  },
  API: {
    type: "product_catalog",
    id: "52ca84bf-c913-4174-be05-c126f270b29e",
    analyticTitle: "Product by Category",
    apiName: "Product by Category",
    apiEndpoint:
      'https://qa-cbu-vbus-tlenaiq-mgr5bk4tqgnlo.eu-5.magentosite.cloud/index.php/graphql?query={ products(filter: {category_id:{eq: <productCategoryID>},price: {from: "0", to: "999999"}}, pageSize: 5, currentPage: 1 sort: {position: DESC}) { total_count page_info { page_size current_page total_pages } items { name sku badges badges_label manufacturer manufacturer_label promotion_tag_label payment_terms_label stock_status low_stock_threshold display_low_stock_badge categories{ id name url_key image } __typename description{ html } meta_title meta_description price_range { minimum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } maximum_price { regular_price { value currency } final_price{ value currency } discount { amount_off percent_off } } } price_tiers{ discount{ amount_off percent_off } final_price{ value currency } quantity } image { url label } small_image{ url label } media_gallery { url label ... on ProductVideo { video_content { media_type video_provider video_url video_title video_description video_metadata } } } } aggregations{ count label attribute_code options{ count label value } } sort_fields{ default options{ label value } } } }',
    method: "GET",
    headers: {
      Store: "cbu",
      "Content-Type": "application/json",
    },
  },
  numOfProducts: "5",
};

export const four_column_usp = {
  type: "four_column_usp",
  id: "70e43a5a-0989-497e-96b3-ff35fc31ca13",
  analyticTitle: "USP - Why shop online",
  title: "Why shop online?",
  description: null,
  items: [
    {
      id: "7bebcd8f-266d-45dd-a218-3b5ab57b33ca",
      description:
        "<p>Shop online, safe and secure with multiple payment options changed.</p>\r\n",
      icon: "http://3.250.153.131/sites/default/files/2020-07/illustration.png",
    },
    {
      id: "4fbb34a8-f5ce-43fd-8271-6d780a6d2f7b",
      description:
        "<p>Free standard delivery on all contracts and orders over R600 changed.</p>\r\n",
      icon: "http://3.250.153.131/sites/default/files/2020-07/illustration4.png",
    },
    {
      id: "96e7da09-e19b-4062-b98c-856855893340",
      description: "<p>Free SIM and connection&nbsp; cahnged.</p>\r\n",
      icon: "http://3.250.153.131/sites/default/files/2020-07/illustration2.png",
    },
    {
      id: "292ac9f2-7e1d-4d11-a511-02ea72600848",
      description: "<p>24/7 Convinience at your fingertips cahnged</p>\r\n",
      icon: "http://3.250.153.131/sites/default/files/2020-07/illustration3.png",
    },
  ],
};

export const banner = {
  type: "banner",
  analyticTitle: "CBU: Entertainment Banner",
  id: "4d0fd645-4561-4840-ad11-b2c973773aab",
  bannerTitle: "EXPLORE",
  bannerSubTitle: "<p>Entertainment</p>",
  bannerImage:
    "http://3.250.153.131/sites/default/files/2020-06/homebanner.png",
  callToActionUrl: "http://example.com",
  callToActionLabel: "Show More",
  buttonStyle: "Primary",
};

export const appstore_banner = {
  type: "appstore_banner",
  id: "c50ba287-3018-42e7-abcb-dd35177bcda7",
  analyticTitle: "Stay In Control Banner",
  icon: "http://3.250.153.131/sites/default/files/2020-06/cellphone-o-copy%403x.png",
  title: "Stay in",
  heading: "<p>Control</p>",
  description:
    "<p>MY VODACOM APP</p><h1>Designed to make your life easier</h1><p>Make life easier by downloading the My Vodacom App,&nbsp; view balances, data usage, buy bundles, airtime, and so much more!</p>",
  backgroundImage:
    "http://3.250.153.131/sites/default/files/2020-06/play-store-banner-desktop-bg.png",
  image: "http://3.250.153.131/sites/default/files/2020-06/bitmap-hand.png",
  buttonItems: [
    {
      id: "6fa5b6c0-2f8d-49ba-8502-e2fabf9ef7fd",
      buttonImage:
        "http://3.250.153.131/sites/default/files/2020-06/google-play%403x.png",
      buttonUrl: "http://example.com.",
    },
    {
      id: "a27df718-1d6a-4ba0-9d74-be2720899149",
      buttonImage:
        "http://3.250.153.131/sites/default/files/2020-06/app-store.png",
      buttonUrl: "http://google.com",
    },
  ],
};
export const process_image_123 = {
  type: "123_process_image",
  id: "1240ad57-2156-43f1-a781-04afccfe51d5",
  analyticTitle: "Demo 1-2-3 Step Process Image - Square Image",
  title: "My New component",
  description:
    "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum non lacus ut turpis hendrerit tristique vel id metus. Cras pretium quam dui, in mollis erat sodales at. Interdum et malesuada fames ac ante ipsum primis in faucibus. Cras ut ex aliquet, condimentum elit ac, ultrices lectus. Cras sagittis, velit nec congue lobortis, arcu velit dapibus velit, eu pretium leo nunc vitae ligula. Etiam vel rutrum odio. Donec lacinia arcu a dolor lacinia, sed tincidunt risus facilisis.</p>",
  items: [
    {
      id: "3907de22-cdbb-4d72-9ede-10867a8d85cc",
      imageStyle: "Square Image",
      title: "Lorem ipsum dolor sit amet",
      description:
        "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>",
      image: "http://3.250.153.131/sites/default/files/2020-07/Group%203.jpg",
    },
    {
      id: "eb9bb7b8-fe02-445a-a0f3-9146ef3330d5",
      imageStyle: "Square Image",
      title: "Lorem ipsum",
      description:
        "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>",
      image: "http://3.250.153.131/sites/default/files/2020-07/Group%205.jpg",
    },
    {
      id: "38a2ac8e-05ba-4f01-a824-d9af11768cae",
      imageStyle: "Square Image",
      title: "Vestibulum eget sempee",
      description:
        "<p>Vestibulum non lacus ut turpis hendrerit tristique vel id metus. Cras pretium quam dui, in mollis erat sodales at. Interdum et malesuada fames ac ante ipsum primis in faucibus. Cras ut ex aliquet, condimentum elit ac, ultrices lectus. Cras sagittis, velit nec congue lobortis, arcu velit dapibus velit, eu pretium leo nunc vitae ligula. Etiam vel rutrum odio. Donec lacinia arcu a dolor lacinia, sed tincidunt risus facilisis.</p>",
      image: "http://3.250.153.131/sites/default/files/2020-07/Group%206.jpg",
    },
  ],
};

export const horizontal_video = {
  type: "horizontal_video",
  id: "bc48ae64-e6eb-495f-afcb-d7ce60813958",
  analyticTitle: "CBU: Horizontal video",
  title: "Explore",
  description: "<p>Vodaworld</p>",
  thumbnail: "http://3.250.153.131/sites/default/files/2020-06/group-67.png",
  thumbnailHeading: "Video",
  thumbnailDesc: "<p>Explore our newly launched Apple boutique now</p>",
  video:
    "http://3.250.153.131/sites/default/files/2020-07/AdobeStock_295620918_Video_HD_Preview.mp4",
};
export const landingPageComponent = {
  type: "promotion_container",
  id: "fcdc6da1-f54e-49e8-8816-3bec5ed5f74e",
  analyticTitle: "Promotional container without button",
  title: "Lorem ipsum dolor sit amet",
  heading: "<p>Heading</p>",
  description:
    "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam congue sed ligula id pulvinar. Aenean blandit libero non metus laoreet vestibulum. Aenean eleifend tristique mauris. Suspendisse consequat risus a scelerisque interdum. Sed posuere mattis posuere. Phasellus purus mi, posuere non tincidunt ultrices, sagittis a dui. Etiam imperdiet quam quis feugiat porta. Fusce imperdiet condimentum nisl, ut egestas sapien viverra eget. In odio ex, posuere nec pretium vel, tempor id sapien. Sed imperdiet quam id lorem euismod faucibus.</p>",
  image: "http://3.250.153.131/sites/default/files/2020-07/Image.png",
};

///____
export const bread_crumb = {
  type: "bread_crumb",
  id: "fcdc6da1-f54e-49e8-8816-3bec5ed5f74e",
  analyticTitle: "Promotional container without button",
  title: "Lorem ipsum dolor sit amet",
  heading: "<p>Heading</p>",
  description:
    "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam congue sed ligula id pulvinar. Aenean blandit libero non metus laoreet vestibulum. Aenean eleifend tristique mauris. Suspendisse consequat risus a scelerisque interdum. Sed posuere mattis posuere. Phasellus purus mi, posuere non tincidunt ultrices, sagittis a dui. Etiam imperdiet quam quis feugiat porta. Fusce imperdiet condimentum nisl, ut egestas sapien viverra eget. In odio ex, posuere nec pretium vel, tempor id sapien. Sed imperdiet quam id lorem euismod faucibus.</p>",
  image: "http://3.250.153.131/sites/default/files/2020-07/Image.png",
};
export const multi_column_card = {
  type: "multi_column_card",
  analyticTitle: "analyticTitle",
  items: "items",
};

export const three_column_plain_cards = {
  type: "3_column_plain_cards",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};

export const paragraph = {
  type: "paragraph",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};

export const two_column_proposition = {
  type: "two_column_proposition",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};
export const calling_costs = {
  type: "calling_costs",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};
export const numerical_counter = {
  type: "numerical_counter",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};
export const countdown_banner = {
  type: "countdown_banner",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};
export const multi_column_proposition = {
  type: "multi_column_proposition",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};
export const testimonial_carousel = {
  type: "testimonial_carousel",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};
export const multi_quadrant_proposition = {
  type: "multi_quadrant_proposition",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};
export const product_carousel = {
  type: "product_carousel",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};
export const accordion = {
  type: "accordion",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};

export const multi_quadrant_phone_visual = {
  type: "multi_quadrant_phone_visual",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};

export const panoramic_image = {
  type: "panoramic_image",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};
export const small_card_image_carousel = {
  type: "small_card_image_carousel",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};
export const shop_category_card_carousel = {
  type: "shop_category_card_carousel",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};
export const shop_brand_card_carousel = {
  type: "shop_brand_card_carousel",
  analyticTitle: "analyticTitle",
  componentTitle: "componentTitle",
};
export const multi_column_usp = {
  type: "multi_column_usp",
  id: "fcdc6da1-f54e-49e8-8816-3bec5ed5f74e",
  analyticTitle: "Promotional container without button",
  title: "Lorem ipsum dolor sit amet",
  heading: "<p>Heading</p>",
  description:
    "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam congue sed ligula id pulvinar. Aenean blandit libero non metus laoreet vestibulum. Aenean eleifend tristique mauris. Suspendisse consequat risus a scelerisque interdum. Sed posuere mattis posuere. Phasellus purus mi, posuere non tincidunt ultrices, sagittis a dui. Etiam imperdiet quam quis feugiat porta. Fusce imperdiet condimentum nisl, ut egestas sapien viverra eget. In odio ex, posuere nec pretium vel, tempor id sapien. Sed imperdiet quam id lorem euismod faucibus.</p>",
  image: "http://3.250.153.131/sites/default/files/2020-07/Image.png",
};

export const deal_catalog = {
  type: "deal_catalog",
  id: "fcdc6da1-f54e-49e8-8816-3bec5ed5f74e",
  analyticTitle: "Promotional container without button",
  title: "Lorem ipsum dolor sit amet",
  heading: "<p>Heading</p>",
  description:
    "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam congue sed ligula id pulvinar. Aenean blandit libero non metus laoreet vestibulum. Aenean eleifend tristique mauris. Suspendisse consequat risus a scelerisque interdum. Sed posuere mattis posuere. Phasellus purus mi, posuere non tincidunt ultrices, sagittis a dui. Etiam imperdiet quam quis feugiat porta. Fusce imperdiet condimentum nisl, ut egestas sapien viverra eget. In odio ex, posuere nec pretium vel, tempor id sapien. Sed imperdiet quam id lorem euismod faucibus.</p>",
  image: "http://3.250.153.131/sites/default/files/2020-07/Image.png",
};
export const defaultCase = {
  type: "default_any",
};

export const defaultPayInt = {
  Transaction: {
    Username: "Pinkflam2",
    Password: "Pinkflam2",
    Destination: "UCF",
    TransactionType: "01",
    SupplierID: "Pink flamingo 2",
    Submission: {
      Number: "3",
      Stamp: Date.now().toString(),
    },
    Identifier: "D7616EEA-6C3D-49E6-AE72-000B451D20D4",
    Currency: "ZAR",
    Order: {
      Products: [
        {
          id: 1,
          ProductCode: "Product1",
          Description: "ProductDescription",
          Quantity: "1",
          Price: "2",
          VatRate: "0",
          Subtotal: "2",
        },
      ],
      Delivery: {
        Auto: "false",
      },
      ProductTotal: "2",
    },
  },
};

export const productOrderReq = {
  productOrder: [
    {
      contact: {
        firstName: "",
        middleName: "",
        lastName1: "",
        lastName2: "",
        identificationID: "",
        identificationType: "",
        expirationDate: "",
        identificationCharacteristics: "",
        gender: "",
        dateOfBirth: "",
        contact: "",
        emailAddress: "",
      },
      externalId: "",
      storeCode: "",
      orderReference: "",
      journeyType: "standalone",
      productOrderItems: {
        productOrderItem: [
          {
            productID: "",
            action: "",
            productName: "",
            lineNumber: "",
            eventTime: "",
            quantity: "",
            unitOfMeasure: "",
            customerItemID: "",
            customerItemIDType: "",
            rechargeType: "",
            validationSysTraceAuditNumber: "",
            validationTransDateTime: "",
            deliveryAddress: {
              country: "",
              stateOrProvince: "",
              supplementaryLocation: {
                addressLine1: "",
                addressLine2: "",
                addressLine3: "",
                addressLine4: "",
                addressLine5: "NA",
              },
              urbanAddress: {
                streetNr: "",
                streetName: "",
                streetType: "",
                locality: "",
                postCode: "",
                deliveryInstructions: "",
              },
            },
            productOrderItemTotal: {
              subTotal: "",
              amount: "",
              dutyFreeAmount: "",
              priceType: "",
              shippingAmount: "",
              taxIncludedAmount: "",
              totalAmount: "",
              unit: "",
              loyaltyPointsTotal: "",
              amountBreakDown: "",
            },
            note: {
              discountedFlag: "",
              portingAuthorisationCode: "",
              priorNumber: "",
              handSetReplacementOffset: "",
              manualFlags: "",
              csrComments: "",
              fixedLineNumber: "",
              newMSISDN: "",
            },
          },
        ],
      },
      productOrderTotal: {
        subTotal: "",
        priceType: "",
        shippingAmount: "",
        taxIncludedAmount: "",
        totalAmount: "",
        unit: "",
        loyaltyPointsTotal: "",
        amountBreakDown: "",
      },
      relatedParties: {
        customerId: "",
        ssoid: "",
        rechargeMSISDN: "",
        customerReference: "",
      },
      payment: {
        paymentReference: {
          country: "string",
          stateOrProvince: "string",
          supplementaryLocation: {
            addressLine1: "string",
            addressLine2: "string",
            addressLine3: "string",
            addressLine4: "string",
            addressLine5: "",
          },
          urbanAddress: {
            streetNr: "string",
            streetName: "string",
            streetType: "string",
            locality: "string",
            postCode: "string",
            deliveryInstructions: "string",
          },
        },
        VoucherNumber: "string",
        type: "CRED_CARD",
        AccountHoldersName: "string",
        voucherNumber: "string",
        AccountHoldersPhone: "string",
        accountHoldersName: "string",
        EncryptedPaymentDetails: "string",
        accountHoldersPhone: "string",
        AuthorisedAmount: "string",
        encryptedPaymentDetails: "string",
        Currency: "string",
        authorisedAmount: "",
        AuthorisationCode: "string",
        unit: "string",
        LoyaltyPoints: "string",
        authorisationCode: "string",
        RecurringPayment: "string",
        loyaltyPoints: "string",
        recurringPayment: "string",
      },
      identifier: {
        applicationID: "string",
        serviceID: "string",
        serviceInterfaceVersion: "string",
        eventTime: "string",
        referenceID: "string",
        identityID: "string",
        correlationID: "string",
      },
      orderTypeFlag: "string",
      productOrderItemCount: "string",
      shipTo: "string",
      shippingMethod: "string",
      Characteristic: {
        name: "string",
      },
      eventTime: "string",
      ricaAddress: {
        address1: "string",
        address2: "string",
        address3: "string",
        city: "string",
        countryID: "string",
        postalCode: "string",
        suburb: "string",
        province: "string",
      },
    },
  ],
};
